import React, { useEffect, useState, useRef, useCallback } from "react";

import {
  Breadcrumb,
  Button,
  Dropdown,
  Image,
  Select,
  AutoComplete,
  Radio,
} from "antd";
import { DoubleRightOutlined, PlusOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import {
  BarcodeInputBox,
  InputBox,
} from "../../../components/CustomWidgets/InputBox";

import { useFormik, isInteger } from "formik";
import "../../../styles.css";
import styles from "./autocomplete.module.css";
import {
  getInventoryEditResttriction,
  InventorySearchonboard,
  InventorySearchonboardBarcode,
} from "../../../API  Functions/InventoryFunctions";
// import { debounce } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
// import Autocomplete from "react-autocomplete";
import { InventoryOnboardSchema } from "../../../components/validationSchema";
import BarcodeScanner from "react-barcode-reader";
import InventoryOnboardPopup from "../../../Popups/InventoryOnboardPopup";
import Navbar from "../../../components/Navbar/Navbar";
import { useSelector } from "react-redux";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { toast } from "react-toastify";
import AddBarcode from "../../../modals/AddBarcodeModal";
import barcodeIcon from "../../../assets/Inventory/barcode_icon.svg";
import AddPackage from "../../../assets/Inventory/AddPackage.svg";
import LoadingSpinner from "../../../components/Loading";
import deleteicon from "../../../assets/Order/Delete.svg";
import { checkPermission } from "../../../Utils/permissionHelper";
import { GetRetailerDetails } from "../../../API  Functions/ProfileFunctions";
import { getProductGroups } from "../../../API  Functions/productGroupFunctions";
import { MultiSelectBox } from "../../../components/CustomWidgets/SelectBox";
import ExpiryModal from "../../../modals/ExpiryModal";
import moment from "moment";

import { Html5Qrcode } from "html5-qrcode";
import { ScanLine } from "lucide-react";

import { useZxing } from "react-zxing";

// Add this near the top of InventoryOnboard
const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);



// Your debounce function
const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    const context = this;
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(context, args), delay);
  };
};

  const BarcodeScannerButton = ({ onScan, disabled }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [result, setResult] = useState("");

    const { ref } = useZxing({
      paused: !isOpen,
      onDecodeResult(result) {
        onScan(result.rawValue);
        setIsOpen(false);
      },
      constraints: {
        video: {
          facingMode: { exact: "environment" },
          width: { ideal: 1280 },
          height: { ideal: 720 },
        }
      }
    });

    return (
      <>
        <button
          type="button"
          disabled={disabled}
          onClick={() => setIsOpen(true)}
          className="absolute top-2 right-8 ..."
        >
          <img src={barcodeIcon} alt="" style={{ height: 30, width: 30 }} />
        </button>

        {isOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="bg-white rounded-xl p-4 w-[320px] shadow-xl">
              <div className="flex justify-between items-center mb-3">
                <h3 className="font-semibold text-gray-700">Scan Barcode</h3>
                <button onClick={() => setIsOpen(false)} className="text-xl">&times;</button>
              </div>
              {/* Just a <video> tag — no div ID hacks needed */}
              <video ref={ref} className="w-full rounded" muted playsInline />
              <p className="text-xs text-gray-400 text-center mt-2">Point camera at barcode</p>
            </div>
          </div>
        )}
      </>
    );
  };




const InventoryOnboard = () => {
  const [value, setValue] = useState("");
  const [requestProduct, setrequestProduct] = useState(false);
  const [Productoptions, setProductoptions] = useState([]);
  const [ProductImage, setProductImage] = useState("");
  const [ProductName, setProductName] = useState("");
  const [availableQty, setAvailableQty] = useState(0); // Step 1: State for available quantity
  const [productUom, setProductUom] = useState(""); // Step 1: State for available quantity
  const [prodUpdateState, setProdUpdateState] = useState(""); // Step 1: State for available quantity
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [addBarcode, setAddBarcode] = useState(false);
  const [addSecondarBarcode, setAddSecondaryBarcode] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isAddBarcodeModalOpen, setIsAddBarcodeModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPackage, setIsPackage] = useState(false);
  const [addPackagesContainer, ShowAddPackagesContainer] = useState(false);
  const [popup, setpopup] = useState(false);
  const [message, setmessage] = useState(" ");
  const [secondBarcode, setSecondaryBarcode] = useState([]);
  const [taxId, setTaxId] = useState("");
  const EGS_PREFIX = `EG-${taxId}-`;
  const [scrollPosition, setScrollPosition] = useState(0);
  const [allGroups, setAllGroups] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [isProductFound, setIsProductFound] = useState(false); // Step 1: State to track if product is found
  const [vatTypes, setVatTypes] = useState([]);
  const [vatPriceType, setVatPriceType] = useState(null);
  const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [costingMethod, setCostingMethod] = useState("");
  const [isExpiryEnabled, setExpiryEnabled] = useState(false);
  const [openExpiryModal, setOpenExpiryModal] = useState(false);
  const [savedExpiryData, setSavedExpiryData] = useState([]);
  const [existingExpiryData, setExistingExpiryData] = useState(null);
  const [isSearching, setIsSearching] = useState(false);




  const [packagesArray, setPackagesArray] = useState([
    // { pack_price: "", pack_qty: "", secondary_barcode: "" },
  ]);
  const [isBarcodeOptional, setIsBarcodeOptional] = useState(false);

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  console.log("savedExpiryData====>", savedExpiryData);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const userData = useSelector((state) => state?.login?.user?.result);
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
  // const searchResult = debounce(async (value) => {

  // }, 1000);

  useEffect(() => {
    GetGroups();
    // GetVatTypes();
    CheckUserAcessForInventory();
    // fetchdetails()
  }, []);

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(user_id);
      if (res?.result?.status_code == 200) {
        setIsEtaEnable(res?.result?.is_eta_enabled);
        setCostingMethod(res?.result?.costing_method);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setTaxId(
          result?.retailer_details?.tax_card_number
            ? result?.retailer_details?.tax_card_number
            : null,
        );
      }
    });
  };

  const GetVatTypes = async () => {
    const payload = {
      retailer_id: company_id,
      offset: 0,
      limit: 1000,
    };
    try {
      const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setVatTypes(res1?.result?.data?.filter((item) => item.is_active));
      } else {
        setVatTypes([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const GetProductExpiryData = async (id) => {
    const payload = {
      company_id: company_id,
      product_id: id,
      start_date: "",
      end_date: "",
      limit: 10,
      offset: 0,
    };
    try {
      const res = await axiosInstance.post(
        URLS.PRODUCT_EXPIRY_DETAILS,
        payload,
      );
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setExistingExpiryData(res1?.result?.data);
      } else {
        setExistingExpiryData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const createProductExpiry = async (id) => {
    const payload = {
      company_id: company_id,
      product_expiry: [
        {
          product_id: id,
          expiry_data: savedExpiryData?.expiryData?.map((expiry) => {
            const formatDate = (value) => {
              if (!value) return "";
              const date = new Date(value);
              const yyyy = date.getFullYear();
              const mm = String(date.getMonth() + 1).padStart(2, "0");
              const dd = String(date.getDate()).padStart(2, "0");
              return `${yyyy}-${mm}-${dd}`;
            };

            return {
              quantity: expiry.qty,
              expiry_date: expiry.expiryDate
                ? formatDate(expiry.expiryDate)
                : "",
              manufacturing_date: expiry.manufactureDate
                ? formatDate(expiry.manufactureDate)
                : "",
              shelf_life_days: expiry.shelfLife,
              lot_number: expiry.batchNumber,
            };
          }),
        },
      ],
    };
    try {
      const res = await axiosInstance.post(URLS.CREATE_PRODUCT_EXPIRY, payload);
      setSavedExpiryData([]);
    } catch (error) {
      console.error("Error fetching KPI data:", error);
    } finally {
    }
  };

  const GetGroups = async () => {
    const payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: company_id,
      user_id: user_id,
      offset: 0,
      limit: 5000,
    };
    try {
      const res1 = await getProductGroups(payload);

      // console.log("res1---->", res1);

      if (res1?.result[0]?.status_code === 200) {
        setAllGroups(res1?.result[0]?.product_groups);
      } else {
        setAllGroups([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  // Update searchResult to set loading state
  const searchResult = useCallback(
    debounce(async (value) => {
      setIsSearching(true);
      try {
        let res = await InventorySearchonboard(value);
        if (res.result && Array.isArray(res.result)) {
          const productResponse = res.result[0];
          if (productResponse.status_code === 400) {
            setrequestProduct(true);
            setProductoptions([]);
          } else {
            setProductoptions(res.result);
            setrequestProduct(false);
          }
        } else {
          setProductoptions([]);
          setrequestProduct(false);
        }
      } finally {
        setIsSearching(false);
      }
    }, 500),
    [],
  );

  const searchBarcodeResult = debounce(async (value) => {
    setLoading(true)
    let res = await InventorySearchonboardBarcode(value);
    setLoading(false)
    // console.log("API Response Barcode:", res);

    if (res.result && Array.isArray(res.result)) {
      const productResponse = res.result[0];
      // console.log("PPPPPp", productResponse);

      if (productResponse.status_code === 400) {
        // If product not found, try fetching from GS1 API
        try {
          const fetchGtinResponse = await axiosInstance.post(
            "/fetch_gs1_data",
            {
              gtin: value, // Use the barcode value
            },
          );

          if (fetchGtinResponse.data && fetchGtinResponse.data.result) {
            const fetchedProduct = fetchGtinResponse.data.result;

            // Check if the fetched product has the necessary data
            if (fetchedProduct.gtin) {
              // Redirect to ProductRequest page with fetched product data
              navigate("/inventory/ProductRequest", {
                state: {
                  fetchedProduct,
                  // product_description_english: fetchedProduct.product_description_english,
                  // product_description_arabic: fetchedProduct.product_description_arabic,
                  // barcode: fetchedProduct.gtin,
                },
              });
            } else {
              // Show the Request Product option if no product found
              setrequestProduct(true);
              setProductoptions([]);
              setValue("");
              setIsProductFound(false);
            }
          } else {
            // Handle case where no result is returned
            setrequestProduct(true);
            setProductoptions([]);
            setValue("");
            setIsProductFound(false);
          }
        } catch (error) {
          console.error("Error fetching GS1 data:", error);
          setrequestProduct(true); // Show Request Product option on error
        }
      } else {
        // Fill out the input fields with the found product data
        formik.setFieldValue("barcode", productResponse.barcode);
        formik.setFieldValue(
          "machine_barcode",
          productResponse?.machine_barcode
            ? productResponse?.machine_barcode
            : "",
        );
        formik.setFieldValue("product_name2", productResponse?.product_name2);
        formik.setFieldValue(
          "isinclusive",
          productResponse?.vat_details?.is_tax_price_inclusive,
        );
        formik.setFieldValue(
          "prevTextId",
          productResponse?.vat_details?.tax_id,
        );
        formik.setFieldValue("tax_id", productResponse?.vat_details?.tax_id);
        formik.setFieldValue(
          "egs_code",
          productResponse?.egs_code ? productResponse?.egs_code : "",
        );
        formik.setFieldValue(
          "groups",
          productResponse?.group_list
            ? productResponse.group_list.map((item) => item.id)
            : [],
        );
        formik.setFieldValue(
          "productShortcut",
          productResponse?.product_shortcut
            ? productResponse?.product_shortcut
            : "",
        );
        setProductImage(productResponse.image);
        setSelectedGroups(
          productResponse?.group_list ? productResponse?.group_list : [],
        );
        setValue(
          productResponse?.barcode
            ? `${productResponse.name} - ${productResponse?.barcode}`
            : `${productResponse.name}`,
        );
        setProductName(productResponse.name);
        setAvailableQty(productResponse.available_qty);
        setProductUom(productResponse.uom);
        setIsPackage(productResponse?.is_package);
        // GetProductExpiryData(productResponse?.prod_id);
        GetProductSecondaryCode(productResponse?.prod_id);
        if (productResponse?.is_package) {
          GetAllPackages(productResponse?.prod_id);
        }

        // console.log("PPP", productResponse);

        if (productResponse?.cost_price > 0) {
          formik.setFieldValue("cost_price", productResponse.cost_price);
        }

        if (productResponse?.sale_price > 0) {
          formik.setFieldValue("sale_price", productResponse.sale_price);
        }

        setIsProductFound(true); // Mark product as found
      }
    }
  }, 1000);
  const handleScroll = (e) => {
    const scrollTop = e.target.scrollTop;
    const itemHeight = 60;
    const index = Math.floor(scrollTop / itemHeight);
    setScrollPosition(index);
  };


  const formik = useFormik({
    initialValues: {
      product_name2: "",
      egs_code: "",
      barcode: "",
      category: "",
      cost_price: "",
      sale_price: "",
      discounted_price: "",
      qty: "",
      machine_barcode: "",
      secondaryBarcode: "",
      productShortcut: "",
      groups: [],
      isinclusive: null,
      tax_id: null,
      prevTextId: null,
      costingMethod: costingMethod,
    },
    enableReinitialize: true,
    validationSchema: InventoryOnboardSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      submitProductData(values);
    },
  });

  const oldEgsCodeRef = useRef(formik.values.egs_code || "");

  const isValidEgsFilled = (egs) => {
    if (!egs) return false;
    if (egs === EGS_PREFIX) return false;
    return egs.length > EGS_PREFIX.length;
  };

  const submitProductData = async (values) => {
    console.log("values===>", values);

    setLoading(true);
    const { barcode, qty, machine_barcode } = values;

    //   const oldEgs = oldEgsCodeRef.current;
    // const newEgs = values.egs_code;

    // const hadEgsBefore = isValidEgsFilled(oldEgs);
    // const hasEgsNow = isValidEgsFilled(newEgs);

    // // 👉 EGS entered now but wasn't there before
    // if (!hadEgsBefore && hasEgsNow) {
    //   try {
    //     const verifyRes = await verifyEgsCodeAPI(newEgs, values?.prod_id || selectedProductId);

    //     if (verifyRes?.result?.status_code !== 200) {
    //       toast.error(t("EGS code not verified"));
    //       setLoading(false);
    //       return;
    //     }
    //   } catch (err) {
    //     toast.error(t("EGS code verification failed"));
    //     setLoading(false);
    //     return;
    //   }
    // }

    if (
      values?.secondaryBarcode &&
      values?.secondaryBarcode != "" &&
      values?.secondaryBarcode != secondBarcode[0]?.barcode
    ) {
      const result = await checkSecondaryBarcode(
        values?.prod_id || selectedProductId,
        values?.secondaryBarcode,
        company_id,
      );
      console.log("result====>", result);

      if (result?.result?.status_code != 200) {
        toast.error(t(result?.result?.status));
        setLoading(false);
        return;
      }
    }

    const cost_price = values.cost_price ? Number(values.cost_price) : 0;
    const sale_price = values.sale_price ? Number(values.sale_price) : 0;
    const discounted_price = values.discounted_price
      ? Number(values.discounted_price)
      : 0;

    const product_name = ProductName || "";
    const product_image = ProductImage || "";
    const totalQuantity =
      availableQty > 0 ? Number(qty) + availableQty : Number(qty);

    if (sale_price < cost_price) {
      toast.error("Sale price cannot be less than cost price");
      setLoading(false);
      // setpopup(true);
      // setmessage("Sale Price cannot be less than Cost Price.");
      return; // Exit the function if validation fails
    }
    // if (sale_price < discounted_price) {
    //   toast.error("Sale price cannot be less than discounted price");
    //   setLoading(false);
    //   // setpopup(true);
    //   // setmessage("Sale Price cannot be less than Cost Price.");
    //   return; // Exit the function if validation fails
    // }

    if (!barcode && !isBarcodeOptional) {
      setAddBarcode(true);
      setLoading(false);
      return;
    }
    if (!qty || !ProductName) {
      setLoading(false);
      // setpopup(true);
      // setmessage("Please fill in all required fields: Quantity, Cost Price, and Sale Price.");
      return; // Exit the function if validation fails
    }

    const isAnyPackageInvalid = packagesArray.some(
      (pkg) => !pkg.pack_qty || !pkg.pack_price || !pkg.secondary_barcode,
    );

    if (isAnyPackageInvalid) {
      toast.error(t("Please fill in all fields for each pack."));
      setLoading(false);
      return;
    }
    // Normalize quantities and check for duplicates
    const qtySet = new Set();
    let hasDuplicateQty = false;

    for (const pkg of packagesArray) {
      const qty = String(pkg.pack_qty).trim(); // convert to string for consistent comparison
      if (qtySet.has(qty)) {
        hasDuplicateQty = true;
        break;
      }
      qtySet.add(qty);
    }

    if (hasDuplicateQty) {
      toast.error(t("Two packages cannot have the same pack quantity."));
      setLoading(false);
      return;
    }

    // Normalize barcodes and check for duplicates
    const barcodeSet = new Set();
    let hasDuplicateBarcode = false;

    for (const pkg of packagesArray) {
      const barcode = String(pkg.secondary_barcode).trim().toLowerCase(); // normalize casing and whitespace
      if (barcodeSet.has(barcode)) {
        hasDuplicateBarcode = true;
        break;
      }
      barcodeSet.add(barcode);
    }

    if (hasDuplicateBarcode) {
      toast.error(t("Two packages cannot have the same barcode."));
      setLoading(false);
      return;
    }

    // Step 3.5: Check if sales price is less than cost price
    const hasInvalidPrice = packagesArray.some((pkg) => {
      const costPrice =
        Number(formik.values?.cost_price || 0) * Number(pkg.pack_qty || 0);
      const salePrice = Number(pkg.pack_price || 0);

      return salePrice < costPrice;
    });

    if (hasInvalidPrice) {
      toast.error(t("Package sale price cannot be less than its cost price."));
      setLoading(false);
      return;
    }

    // Sanitize package data
    const sanitizedPackages = packagesArray.map((pkg) => ({
      pack_qty: pkg.pack_qty ? Number(pkg.pack_qty) : 0,
      pack_price: pkg.pack_price ? Number(pkg.pack_price) : 0,
      secondary_barcode: pkg.secondary_barcode || "",
    }));

    if (values?.secondaryBarcode == barcode) {
      toast.error(t("Primary Barcode and Secondary Barcode can not be same"));
      return;
    }

    const existingGroupIds = Array.isArray(selectedGroups)
      ? selectedGroups.map((g) => g.id)
      : [];

    const removeGroupIds = existingGroupIds.filter(
      (id) => !values.groups.includes(id),
    );

    const payload = {
      barcode: barcode || "",
      quantity: totalQuantity,
      product_name,
      product_name2:
        values?.product_name2?.trim() === ""
          ? ""
          : values?.product_name2?.trim(),
      // egs_code: values?.egs_code,
      product_shortcut:
        values?.productShortcut?.trim() === ""
          ? ""
          : values?.productShortcut?.trim(),
      cost_price: cost_price ? Number(cost_price) : 0,
      sales_price: sale_price ? Number(sale_price) : 0,
      discounted_price:
        discounted_price > sale_price
          ? sale_price
            ? Number(sale_price)
            : 0
          : discounted_price
            ? Number(discounted_price)
            : 0,
      company_id,
      product_image,
      machine_barcode: machine_barcode || false,
      packages: sanitizedPackages,
      is_update_package: addPackagesContainer,
      product_id: values.prod_id || selectedProductId, // <-- add product_id
      add_group_ids:
        values?.groups && !userData?.is_sub_store && !userData?.is_warehouse
          ? values?.groups
          : [],
      remove_group_ids:
        !userData?.is_sub_store && !userData?.is_warehouse
          ? removeGroupIds
          : [],
      // tax_id: values?.tax_id,
      // remove_tax_id: (values.prevTextId == null || values?.tax_id == values.prevTextId) ? null : values.prevTextId,
      // is_tax_price_inclusive: values?.isinclusive == true ? true : false,
    };

    try {
      const response = await axiosInstance.post(URLS.ADD_PRODUCT, payload);
      // console.log("API RESPONSE", response);

      if (
        response?.data?.result?.status_code === 400 &&
        response?.data?.result?.status ===
        "Entered short code is already linked with another product."
      ) {
        toast.error(
          t(
            "Product Short Code Already Exists. Please Use a Different Short Code.",
          ),
        );
        setLoading(false);
        return;
      }
      if (response?.data?.result?.status_code === 400) {
        toast.error(
          t(response?.data?.result?.status),
        );
        setLoading(false);
        return;
      }

      if (response?.data?.result?.status === "Product Created.") {
        if (
          values?.secondaryBarcode != "" &&
          values?.secondaryBarcode != secondBarcode[0]?.barcode
        ) {
          handleAddSecondaryBarcode(
            values.prod_id || selectedProductId,
            values?.secondaryBarcode,
          );
        }
        if (isExpiryEnabled) {
          createProductExpiry(values.prod_id);
        }

        setpopup(true);
        setmessage("Inventory Updated Successfully");
        setProductoptions([]);
        setPackagesArray([]);
        formik.resetForm();
        setLoading(false);
        setProductImage("");
        setProductName("");
        setValue("");
        setAvailableQty(0);
        formik.setFieldValue("product_name2", "");
        formik.setFieldValue("groups", []);
        formik.setFieldValue("isinclusive", null);
        formik.setFieldValue("machine_barcode", "");

        formik.setFieldValue("prevTextId", null);

        formik.setFieldValue("tax_id", null);
        formik.setFieldValue("egs_code", "");

        formik.setFieldValue("productShortcut", "");
        setProductUom("");
        setIsPackage(false);
        setSelectedGroups([]);
        setIsProductSelected(false);
        ShowAddPackagesContainer(false);
        setProdUpdateState("");
        setSecondaryBarcode([]);
        setExpiryEnabled(false);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      setpopup(true);
      setmessage("Error submitting data. Please try again.");
    }
  };

  const checkSecondaryBarcode = async (
    product_id,
    secondaryBarcode,
    company_id,
  ) => {
    try {
      const body = {
        product_id: product_id || 0, // if new product, send 0
        barcode: secondaryBarcode,
        company_id,
      };

      const res = await axiosInstance.post("/Store/2/CheckBarcode", body);

      return res?.data;
      // Example expected: "Barcode already exists" or "Barcode available"
    } catch (error) {
      console.error("Error checking barcode:", error);
      return "error";
    }
  };

  const verifyEgsCodeAPI = async (egsCode, prod_id) => {
    try {
      const body = {
        product_id: prod_id || 0, // if new product, send 0
        egs_code: egsCode,
        company_id,
      };

      const res = await axiosInstance.post(URLS.VERIFY_EGS_CODE, body);

      return res?.data;
      // Example expected: "Barcode already exists" or "Barcode available"
    } catch (error) {
      console.error("Error checking barcode:", error);
      return "error";
    }
  };

  const GetProductSecondaryCode = async (id) => {
    const payload = {
      company_id: company_id,
      product_id: id,
      user_id: user_id,
    };
    try {
      const response = await axiosInstance.post(
        URLS.GET_SECONDARY_BARCODE,
        payload,
      );

      if (response?.data?.result[0]?.status_code === 200) {
        setSecondaryBarcode(response?.data?.result[0]?.response);
        formik.setFieldValue(
          "secondaryBarcode",
          response?.data?.result[0]?.response[0]?.barcode,
        );
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleAddSecondaryBarcode = async (id, code) => {
    const hasExisting =
      Array.isArray(secondBarcode) && secondBarcode?.length > 0;

    // If ANY existing barcode is different, delete ALL existing ones
    const isDeletePrev =
      hasExisting && !secondBarcode?.some((b) => b.barcode === code);

    const payload = {
      company_id: company_id,
      product_id: id,
      barcode_data: [
        // NEW BARCODE
        {
          id: false,
          is_delete: false,
          barcode: code,
        },

        // DELETE ALL PREVIOUS BARCODES
        ...(isDeletePrev
          ? secondBarcode.map((item) => ({
            id: item.id,
            is_delete: true,
            barcode: item.barcode,
          }))
          : []),
      ],
    };

    try {
      const response = await axiosInstance.post(
        URLS.ADD_SECONDARY_BARCODE,
        payload,
      );

      if (response?.data?.result?.status_code != 200) {
        toast.error(response?.data?.result?.status);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleBarcodeClick = () => {
    // console.log("CHAAAA");
    // console.log("Name", ProductName);
    // console.log("Barcoe", formik.values.barcode);

    if (ProductName && !formik.values.barcode && !isBarcodeOptional) {
      setAddBarcode(true);
    }
  };


  const isSaveDisabled =
    !ProductName || (!formik.values.barcode && !isBarcodeOptional); // Check if product name or barcode is empty

  const GetAllPackages = async (prodId) => {
    try {
      let payload = {
        product_id: prodId,
        user_id: user_id,
        company_id: company_id,
      };
      const response = await axiosInstance.post(
        URLS.GET_PRODUCT_PACKAGE,
        payload,
      );
      // console.log("GetAllPackages===>", response?.data);
      if (response?.data?.result[0]?.status_code == 200) {
        ShowAddPackagesContainer(true);
        setPackagesArray(response?.data?.result[0]?.response);
      } else {
        // setPackagesArray([])
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleAddPackage = () => {
    setPackagesArray((prev) => [
      ...prev,
      { pack_price: "", pack_qty: "", secondary_barcode: "" },
    ]);
  };

  const handleDeletePackage = (index) => {
    const updated = packagesArray.filter((_, i) => i !== index);
    if (updated.length === 0) {
      setPackagesArray([]);
      ShowAddPackagesContainer(false);
    } else {
      setPackagesArray(updated);
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...packagesArray];
    updated[index][field] = value;
    setPackagesArray(updated);
  };

  const handleSaveExpiryData = (
    expiryData,
    expiryAlert,
    alertDays,
    productIndex,
  ) => {
    setSavedExpiryData({ expiryData, expiryAlert, alertDays });
  };

  const showCustomName =
    !userData?.is_sub_store || formik.values.product_name2 !== "";

  const showShortcut =
    !userData?.is_sub_store || formik.values.productShortcut !== "";

  const visibleCount = [showCustomName, showShortcut].filter(Boolean).length;
  const widthClass = visibleCount === 2 ? "w-[95%] md:w-6/12" : "w-full";

  return (
    <>
      {loading && <LoadingSpinner />}

      <Navbar heading="Add Products" />
      <div className="bg-[#F6F7F9]">
        <div className="flex flex-col ">
          <div className="mr-4 ml-4 font-extrabold">
            {/* <Breadcrumb
              separator={<DoubleRightOutlined />}
              items={[
                {
                  title: (
                    <Link to={routes.inventory.root}>{t("inventory")}</Link>
                  ),
                  key: "inventory",
                },
                { title: t("Inventory Onboard") },
              ]}
              className="relative mt-3"
            /> */}
          </div>
          <div className="flex flex-row items-end justify-start">
            <div className="flex flex-row justify-end relative bottom-6  w-180 mt-4 me-4"></div>
          </div>
          <div className="mx-2 h-12 rounded-t-xl bg-[#C9ECF7] sm:mx-4">
            <p className="mt-3 ms-4">{t("Product Details")}</p>
          </div>
          <div className="flex flex-col-reverse md:flex-row bg-white mx-2 md:mx-4 border rounded-b-xl">
            <div className="m-2 w-full md:w-8/12 p-1 md:p-4">
              <div className="flex items-center justify-between md:gap-3 w-[95%] md:w-full">
                <span className="relative w-[62%]  md:w-9/12">
                  <label htmlFor="default-search" className="sr-only">
                    Product
                  </label>
                  <div className="w-[95%] md:w-full">
                    <AutoComplete
                      value={value}
                      options={Productoptions.map((option) => ({
                        value: option.name,
                        label: (
                          <span>
                            {option.barcode
                              ? `${option.name} - ${option.barcode}`
                              : `${option.name}`}
                          </span>
                        ),
                      }))}
                      notFoundContent={
                        isSearching ? (
                          <div className="flex justify-center py-2">
                            <span className="animate-spin inline-block w-5 h-5 border-2 border-blue-500 border-t-transparent rounded-full" />
                          </div>
                        ) : null
                      }
                      onSearch={(value) => {
                        if (!isProductSelected) {
                          setValue(value);
                          if (value.length >= 3) {
                            setIsSearching(true); // ← show spinner immediately on type
                            searchResult(value);
                          } else {
                            setrequestProduct(false);
                            setProductoptions([]);
                          }
                        }
                      }}
                      onSelect={(value) => {
                        const selectedProduct = Productoptions.find(
                          (product) => product.name === value,
                        );
                        setIsBarcodeOptional(
                          selectedProduct?.is_barcode_optional,
                        );
                        // if (selectedProduct?.barcode === false) {
                        if (
                          selectedProduct?.barcode === false &&
                          selectedProduct?.is_barcode_optional === false
                        ) {
                          setAddBarcode(true);
                          setIsAddBarcodeModalOpen(true);
                          setSelectedProductId(selectedProduct.prod_id);
                        }
                        setValue(
                          selectedProduct.barcode
                            ? `${selectedProduct.name} - ${selectedProduct.barcode}`
                            : `${selectedProduct.name}`,
                        );
                        setProductImage(selectedProduct?.image);
                        setProductName(selectedProduct?.name);
                        formik.setFieldValue(
                          "product_name2",
                          selectedProduct?.product_name2,
                        );
                        formik.setFieldValue(
                          "isinclusive",
                          selectedProduct?.vat_details?.is_tax_price_inclusive,
                        );
                        formik.setFieldValue(
                          "prevTextId",
                          selectedProduct?.vat_details?.tax_id,
                        );
                        formik.setFieldValue(
                          "tax_id",
                          selectedProduct?.vat_details?.tax_id,
                        );
                        formik.setFieldValue(
                          "egs_code",
                          selectedProduct?.egs_code
                            ? selectedProduct?.egs_code
                            : "",
                        );
                        formik.setFieldValue(
                          "groups",
                          selectedProduct?.group_list
                            ? selectedProduct.group_list.map((item) => item.id)
                            : [],
                        );
                        setSelectedGroups(
                          selectedProduct?.group_list
                            ? selectedProduct?.group_list
                            : [],
                        );
                        formik.setFieldValue(
                          "productShortcut",
                          selectedProduct?.product_shortcut
                            ? selectedProduct?.product_shortcut
                            : "",
                        );

                        setAvailableQty(selectedProduct?.available_qty);
                        setIsPackage(selectedProduct?.is_package);
                        //  GetProductExpiryData(selectedProduct?.prod_id);
                        GetProductSecondaryCode(selectedProduct?.prod_id);
                        if (selectedProduct?.is_package) {
                          GetAllPackages(selectedProduct?.prod_id);
                        }
                        formik.setFieldValue(
                          "barcode",
                          selectedProduct?.barcode,
                        );
                        formik.setFieldValue(
                          "machine_barcode",
                          selectedProduct?.machine_barcode
                            ? selectedProduct?.machine_barcode
                            : "",
                        );
                        formik.setFieldValue(
                          "prod_id",
                          selectedProduct?.prod_id,
                        );
                        setProductUom(selectedProduct?.uom);
                        if (selectedProduct?.sale_price == 0.0) {
                          formik.setFieldValue("sale_price", "");
                        } else if (selectedProduct?.sale_price) {
                          formik.setFieldValue(
                            "sale_price",
                            selectedProduct?.sale_price,
                          );
                        }
                        if (selectedProduct?.cost_price == 0.0) {
                          formik.setFieldValue("cost_price", "");
                        } else if (selectedProduct?.cost_price) {
                          formik.setFieldValue(
                            "cost_price",
                            selectedProduct?.cost_price,
                          );
                        }
                        if (selectedProduct?.discounted_price == 0.0) {
                          formik.setFieldValue("discounted_price", "");
                        } else if (
                          selectedProduct?.discounted_price &&
                          selectedProduct?.discounted_price !==
                          selectedProduct?.sale_price
                        ) {
                          formik.setFieldValue(
                            "discounted_price",
                            selectedProduct?.discounted_price,
                          );
                        }

                        setProdUpdateState(selectedProduct?.updated);
                        setIsProductSelected(true);
                        setProductoptions([]);
                      }}
                      style={{ width: "100%", height: "45px" }}
                      placeholder={t("search_product")}
                      readOnly={isProductSelected}
                      disabled={isAddBarcodeModalOpen}
                    />
                    {/* Camera scan button - mobile only */}
                    {!isProductFound && (<div className="block md:hidden">
                      <BarcodeScannerButton
                        disabled={isAddBarcodeModalOpen}
                        onScan={(data) => {
                          if (!isAddBarcodeModalOpen) {
                            setValue(data);
                            searchBarcodeResult(data);
                          }
                        }}
                      />
                    </div>
                    )
                    }

                    {value && (
                      <button
                        type="button"
                        onClick={() => {
                          setValue(""); // Clear the input value
                          setProductoptions([]); // Clear the product options
                          setIsSearching(false);
                          setrequestProduct(false);
                          setValue(null);
                          setProductImage(null);
                          setProductName(null);
                          setAvailableQty(null);
                          formik.setFieldValue("product_name2", "");
                          formik.setFieldValue("egs_code", "");

                          formik.setFieldValue("productShortcut", "");
                          formik.setFieldValue("groups", []);
                          formik.setFieldValue("isinclusive", null);
                          formik.setFieldValue("prevTextId", null);

                          formik.setFieldValue("tax_id", null);
                          setSelectedGroups([]);
                          setProdUpdateState("");
                          setIsProductSelected(false);
                          setSecondaryBarcode([]);
                          ShowAddPackagesContainer(false);
                          setPackagesArray([]);
                          formik.setFieldValue("barcode", "");
                          formik.setFieldValue("machine_barcode", "");

                          formik.setFieldValue("prod_id", "");
                          formik.setFieldValue("cost_price", "");
                          formik.setFieldValue("sale_price", "");
                          formik.setFieldValue("discounted_price", "");
                          formik.setFieldValue("secondaryBarcode", "");
                          formik.setFieldValue("qty", "");
                          setIsProductFound(false)
                        }}
                        className={`absolute 
      ${i18n.language === "ar" ? "left-2 md:left-2" : "right-8 md:right-2"} 
      top-2 text-gray-500 hover:text-gray-700`}
                      // className="absolute right-2 top-2 text-gray-500 hover:text-gray-700"
                      >
                        &times;
                      </button>
                    )}
                  </div>


                </span>
                <Link to="/inventory/ProductRequest" className="shrink-0">
                  <button
                    type="button"
                    className="flex items-center gap-1.5 h-[45px] px-2 md:px-4 bg-white border border-primaryBlue text-primaryBlue text-xs md:text-sm font-semibold rounded-md md:rounded-lg hover:bg-primaryBlue hover:text-white transition-all duration-200 whitespace-nowrap"
                  >
                    <PlusOutlined style={{ fontSize: "0.85em" }} />
                    {t("Request Product")}
                  </button>
                </Link>
              </div>
              {requestProduct && !isSearching && (
                <p className="text-sm text-gray-600 mt-1 ms-1">
                  {t("No matching product found")}
                </p>
              )}

              {/* {isPackage && ( */}
              <>
              {!addPackagesContainer &&
                !userData?.is_sub_store && !userData?.is_warehouse && !allStores &&
                  ProductName?.length > 0 &&
                  (productUom === "Units" || productUom === "الوحدات") && (
                    <div className="flex cursor-pointer justify-end mt-1 me-4 md:me-0">
                      <span
                        onClick={() => {
                          if (!addPackagesContainer) {
                            setPackagesArray((prev) => [
                              ...prev,
                              {
                                pack_price: "",
                                pack_qty: "",
                                secondary_barcode: "",
                              },
                            ]);
                          }
                          ShowAddPackagesContainer(true);
                        }}
                        className="font-medium text-base text-[#7EC242]"
                      >
                        {t("Add Package")}
                      </span>
                    </div>
                  )}
                {addPackagesContainer && (
                  <div className="bg-[#F5F5F5] rounded-lg p-5 mt-3">
                    <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                      <span className="font-medium">
                        {t("Package Details")}
                      </span>
                      {!userData?.is_sub_store &&
                        !userData?.is_warehouse &&
                        !allStores && (
                          <div
                            onClick={handleAddPackage}
                            className="flex rounded-md py-2 px-3 bg-[#7EC242] text-white font-normal text-sm cursor-pointer items-center"
                          >
                            <img
                              className="me-2 w-4 h-4"
                              src={AddPackage}
                              alt="add"
                            // onClick={() => handleDeletePackage(index)}
                            />
                            {t("Add New Pack")}
                          </div>
                        )}
                    </div>

                    {packagesArray.map((pack, index) => (
                      <div
                        key={index}
  className="mb-5 mt-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1fr_40px] gap-4 items-center"
                      >
                        {/* Barcode: Allow only integers (no decimal) */}
                        <span className="w-full">
                          <InputBox
                            label={t("Barcode")}
                            placeholder={t("Enter Barcode")}
                            backgroundColor={"bg-white"}
                            readOnly={
                              userData?.is_sub_store ||
                              userData?.is_warehouse ||
                              allStores
                            }
                            value={pack.secondary_barcode}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (/^\d{0,18}$/.test(val)) {
                                handleChange(index, "secondary_barcode", val);
                              }
                            }}
                          />
                        </span>
                        {/* Pack Quantity: Allow numbers with up to 2 decimals */}
                        <span className="w-full">
                          <InputBox
                            label={t("Pack Quantity")}
                            placeholder={t("Enter Pack Quantity")}
                            backgroundColor={"bg-white"}
                            readOnly={
                              userData?.is_sub_store ||
                              userData?.is_warehouse ||
                              allStores
                            }
                            value={pack.pack_qty}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (/^\d{0,3}$/.test(val) || val === "") {
                                handleChange(index, "pack_qty", val);
                              }
                            }}
                          />
                        </span>

                        {/* Sale Price: Allow numbers with up to 2 decimals */}
                        <span className="w-full">
                          <InputBox
                            label={t("Sale Price")}
                            placeholder={t("Enter Sale Price")}
                            backgroundColor={"bg-white"}
                            readOnly={
                              userData?.is_sub_store ||
                              userData?.is_warehouse ||
                              allStores
                            }
                            value={pack.pack_price}
                            onChange={(e) => {
                              const val = e.target.value;
                              const regex = /^\d{0,7}(\.\d{0,2})?$/;

                              if (regex.test(val) || val === "") {
                                handleChange(index, "pack_price", val);
                              }
                            }}
                          />
                        </span>
                        <span className="w-full">
                          <InputBox
                            backgroundColor={"bg-[#EBEBEB]"}
                            label={t("Cost Price")}
                            placeholder={t("")}
                            value={formik.values.cost_price * pack.pack_qty}
                            readOnly={true}
                          // onChange={(e) => {
                          //   const val = e.target.value;
                          //   const regex = /^\d{0,7}(\.\d{0,2})?$/;
                          //   if (regex.test(val) || val === "") {
                          //     handleChange(index, "pack_price", val);
                          //   }
                          // }}
                          />
                        </span>

                        {!userData?.is_sub_store &&
                          !userData?.is_warehouse &&
                          !allStores && (
                            <img
                              className="mx-1 mt-1 h-5 w-5 cursor-pointer sm:mt-2 lg:mt-10"
                              src={deleteicon}
                              alt="deleteicon"
                              onClick={() => handleDeletePackage(index)}
                            />
                          )}
                      </div>
                    ))}
                    {packagesArray?.length > 0 &&
                      !userData?.is_sub_store &&
                      !userData?.is_warehouse &&
                      !allStores && (
                        <span className="mt-3 text-sm">
                          {t(
                            "Note: Removing a pack here will not remove it from the Cashier system.",
                          )}
                        </span>
                      )}
                  </div>
                )}
              </>

              {/* )} */}
              <BarcodeScanner
                onScan={(data) => {
                  console.log("isAddBarcodeModalOpen", isAddBarcodeModalOpen);

                  if (!isAddBarcodeModalOpen) {
                    // Check if the modal is not open
                    console.log("BArcode O Data", data);
                    setValue(data);
                    searchBarcodeResult(data);
                  }
                }}
                onError={(err) => {
                  console.error(err);
                }}
                disabled={isAddBarcodeModalOpen}
                facingMode="environment"
                className="absolute inset-y-0 right-0 me-4 pointer-events-none cursor-pointer z-10"
              />
              {/* {requestProduct && (
                <Link
                  to="/inventory/ProductRequest"
                  style={{ color: "blue", textDecoration: "underline" }}
                  className="flex flex-col items-end text-sm"
                >
                  {t("Request Product")}{" "}
                </Link>
              )} */}

              <form onSubmit={formik.handleSubmit}>
                {(showCustomName || showShortcut) && (
                  <div className="flex gap-1 md:gap-3 flex-col md:flex-row ">
                    {showCustomName && (
                      <div className={`block leading-[0px] ${widthClass}`}>
                        <InputBox
                          name="product_name2"
                          label={t("Custom Product Name")}
                          placeholder={t("Enter Custom Product Name")}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "product_name2",
                              e.target.value,
                            )
                          }
                          onBlur={formik.handleBlur}
                          value={formik.values.product_name2}
                          readOnly={userData?.is_sub_store}
                          maxLength={150}
                        />
                      </div>
                    )}

                    {showShortcut && (
                      <div className={`block leading-[0px] ${widthClass}`}>
                        <InputBox
                          label={t("Product Short Code")}
                          name="productShortcut"
                          placeholder={t("Enter Product Short Code")}
                          onChange={(e) =>
                            formik.setFieldValue(
                              "productShortcut",
                              e.target.value,
                            )
                          }
                          onBlur={formik.handleBlur}
                          value={formik.values.productShortcut}
                          readOnly={userData?.is_sub_store}
                          maxLength={10}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) e.preventDefault();
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}

                <div className="flex flex-col items-start gap-1 md:gap-3 md:flex-row md:items-end">
                  <span
                    className={`block w-full leading-[0px] ${!userData?.is_sub_store ||
                      formik.values.productShortcut !== ""
                      ? "md:me-3 md:w-6/12"
                      : "w-full"
                      }`}
                  >
                    {/* <label className="text-sm">{t("barcode")}</label> */}
                    <BarcodeInputBox
                      label={t("Barcode")}
                      type="number"
                      reqiured
                      className={`${formik.errors.barcode ? "border-red" : ""}`}
                      name="barcode"
                      barcodeIcon={barcodeIcon}
                      placeholder={t("Scan Barcode")}
                      onClick={handleBarcodeClick}
                      // max={9999999999999}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.barcode}
                      error={formik.errors.barcode}
                      touched={formik.errors.barcode}
                      disabled={
                        formik.values.barcode?.length >= 13 ||
                        isAddBarcodeModalOpen
                      }
                      readOnly
                    />
                  </span>

                  {(!userData?.is_sub_store ||
                    formik.values.secondaryBarcode !== "") && (
                      <span className="block w-[95%] leading-[0px] md:w-6/12">
                        <InputBox
                          label={t("Secondary Barcode")}
                          type="number"
                          className={`${formik.errors.secondaryBarcode ? "border-red" : ""
                            }`}
                          name="secondaryBarcode"
                          placeholder={t("Enter Secondary Barcode")}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (/^\d{0,18}$/.test(val)) {
                              formik.setFieldValue("secondaryBarcode", val);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.secondaryBarcode}
                          error={formik.errors.secondaryBarcode}
                          touched={formik.errors.secondaryBarcode}
                          readOnly={userData?.is_sub_store}
                          maxLength={14}
                        />
                      </span>
                    )}
                </div>
                {/* {isEtaEnable == true && (
                  <>
                    {!userData?.is_sub_store && taxId != null && (
                      <span className="block leading-[0px] w-full">
                        <InputBox
                          name="egs_code"
                          label={t("EGS Code")}
                          placeholder={t("Enter EGS Code")}
                          value={
                            formik.values.egs_code?.startsWith(EGS_PREFIX)
                              ? formik.values.egs_code
                              : EGS_PREFIX
                          }
                          readOnly={
                            userData?.is_sub_store || userData?.is_warehouse
                          }
                          maxLength={30}
                          onChange={(event) => {
                            let value = event.target.value;

                            // If user tries to delete prefix, restore it
                            if (!value.startsWith(EGS_PREFIX)) {
                              value = EGS_PREFIX;
                            }

                            // Allow only digits after prefix
                            const suffix = value
                              .slice(EGS_PREFIX.length)
                              .replace(/[^0-9]/g, "");

                            formik.setFieldValue(
                              "egs_code",
                              EGS_PREFIX + suffix,
                            );
                          }}
                          onKeyDown={(e) => {
                            const cursorPosition = e.target.selectionStart;

                            // Prevent backspace/delete inside prefix
                            if (
                              (e.key === "Backspace" || e.key === "Delete") &&
                              cursorPosition <= EGS_PREFIX.length
                            ) {
                              e.preventDefault();
                            }
                          }}
                          onBlur={formik.handleBlur}
                        />
                      </span>
                    )}
                    <div className="mt-3 flex w-full justify-between">
                      <div className="w-1/2 me-7">
                        <h3 className="text-sm font-normal mb-2 text-gray-600">
                          {t("Tax")}
                        </h3>
                        <Select
                          style={{ width: "100%" }}
                          placeholder={t("Select Tax")}
                          className="h-10"
                          value={formik.values?.tax_id}
                          onChange={(value) =>
                            formik.setFieldValue("tax_id", value)
                          }
                          getPopupContainer={(triggerNode) =>
                            triggerNode.parentElement
                          }
                          options={vatTypes.map((vat) => ({
                            label: `${vat.tax_name} (${vat.tax_rate_percent}%)`,
                            value: vat.id,
                          }))}
                        />
                      </div>
                      <div className="w-1/2 flex flex-col">
                        <h3 className="text-sm font-normal mb-2 text-gray-600">
                          {t("Tax Type")}
                        </h3>

                        <Radio.Group
                          value={
                            formik.values?.isinclusive == true
                              ? "inclusive"
                              : formik.values?.isinclusive == false
                                ? "exclusive"
                                : null
                          }
                          onChange={(e) =>
                            formik.setFieldValue(
                              "isinclusive",
                              e.target.value == "inclusive" ? true : false,
                            )
                          }
                        >
                          <Radio value="exclusive">{t("Exclusive")}</Radio>
                          <Radio value="inclusive">{t("Inclusive")}</Radio>
                        </Radio.Group>
                      </div>
                    </div>
                  </>
                )} */}

                {!userData?.is_sub_store &&
                  !userData?.is_warehouse &&
                  isProductSelected && (
                    <div className="mt-3">
                      <MultiSelectBox
                        label={t("Product Groups")}
                        name="groups"
                        onChange={(event) => {
                          console.log("categories==>", event.target.value);
                          formik.setFieldValue("groups", event.target.value);
                        }}
                        placeholder={t("Select Groups")}
                        defaultValue={selectedGroups?.map((item) => ({
                          value: item?.id,
                          label:
                            i18n.language == "ar" ? item?.name_ar : item?.name,
                        }))}
                        options={[
                          ...allGroups?.map((item) => ({
                            value: item?.id,
                            label:
                              i18n.language == "ar"
                                ? item?.name_ar
                                : item?.name,
                          })),
                        ]}
                        disabled={!isProductSelected}
                      />
                    </div>
                  )}
                <div className="mt-1 flex gap-3 flex-row md:gap-5 w-[95%] md:w-full">
                  <span className="w-full leading-[0px]">
                    {/* <label className="text-sm">{t("quantity")}</label> */}
                    <InputBox
                      label={t("quantity")}
                      name="qty"
                      reqiured
                      type="text" // Change to text to handle custom validation
                      className={`${formik.errors.qty ? "border-red" : ""}`}
                      placeholder={t("Enter Quantity")}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only valid input based on UOM
                        if (
                          (productUom !== "Units" &&
                            /^\d*\.?\d{0,2}$/.test(value)) || // Allow decimals for non-units
                          (productUom === "Units" && /^\d{0,6}$/.test(value)) // Only whole numbers for units
                        ) {
                          // Prevent multiple hyphens and other invalid characters
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("qty", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.qty}
                      error={formik.errors.qty}
                      touched={formik.errors.qty}
                      disabled={isAddBarcodeModalOpen}
                    />
                    {/* <InputBox
                      name="qty"
                      type="number"
                      className={`${
                        formik.errors.qty
                          ? "border-red" // Apply red border when touched or notification shown
                          : ""
                      }`}
                      placeholder={t("Enter Quantity")}
                      // onChange={formik.handleChange}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only numbers and restrict to 7 digits
                        // if (/^\d{0,5}$/.test(value)) {
                        //   formik.setFieldValue("qty", value);
                        // }
                        if (
                          (productUom !== "Units" &&
                            /^\d*\.?\d{0,2}$/.test(value)) ||
                          (productUom === "Units" && /^\d{0,5}$/.test(value))
                        ) {
                          formik.setFieldValue("qty", value);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.qty}
                      error={formik.errors.qty}
                      touched={formik.errors.qty}
                    /> */}
                    {/* {availableQty > 0 && (
                      <p className="text-sm mt-1 italic text-red">
                        {t("Available Quantity:")} {availableQty}
                      </p>
                    )} */}

                    {prodUpdateState === "Already Updated" ? (
                      availableQty === 0 ? ( // Check if availableQty is 0
                        <p className="text-sm mt-1 italic text-red">
                          {t("Available Quantity: 0")}
                        </p>
                      ) : (
                        <p className="text-sm mt-1 italic text-primaryBlue">
                          {/* {t("Inventory already updated for this product.")}
                          <br /> */}
                          <p className="text-sm mt-0 italic text-red">
                            {t("Available Quantity:")} {availableQty}
                          </p>
                        </p>
                      )
                    ) : availableQty > 0 ? (
                      <p className="text-sm mt-1 italic text-red">
                        {t("Available Quantity:")} {availableQty}
                      </p>
                    ) : null}
                  </span>
                  {(productUom === "KG" ||
                    productUom == "كجم" ||
                    productUom == "Liter" ||
                    productUom == "لتر" ||
                    productUom == "Meter") && (
                      <span className="w-full leading-[0px]">
                        {/* <label className="text-sm">{t("Machine Barcode")}</label> */}
                        <InputBox
                          label={t("Weighing Scale Product Code")}
                          name="machine_barcode"
                          type="number"
                          className={`${formik.errors.machine_barcode ? "border-red" : ""
                            }`}
                          placeholder={t("Enter Product Code")}
                          onChange={(event) => {
                            const { value } = event.target;

                            // Allow only numbers and restrict to 7 digits
                            if (/^\d{0,7}$/.test(value)) {
                              formik.setFieldValue("machine_barcode", value);
                            }
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.machine_barcode}
                          error={formik.errors.machine_barcode}
                          touched={formik.errors.machine_barcode}
                          disabled={isAddBarcodeModalOpen}
                        />
                      </span>
                    )}
                </div>
                {/* <div className=" flex gap-x-2 items-center mt-4">
                  <p className="text-sm font-medium">{t("Product Expiry")}</p>
                  <label className="flex cursor-pointer select-none items-center me-7">
                    <div className="relative">
                      <input
                        type="checkbox"
                        checked={isExpiryEnabled}
                        onChange={() => setExpiryEnabled(!isExpiryEnabled)}
                        className="sr-only"
                         disabled={!isProductSelected}
                      />
                      <div
                        className={`box block h-6 w-12 rounded-full ${
                          isExpiryEnabled ? "bg-green-500" : "bg-gray-500"
                        }`}
                      ></div>
                      <div
                        className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${
                          isExpiryEnabled ? "translate-x-full" : ""
                        }`}
                      ></div>
                    </div>
                  </label>

                    {isExpiryEnabled && (
                      <div
                        onClick={()=>setOpenExpiryModal(true)}
                        className="flex rounded-md py-2 px-3 bg-[#7EC242] text-white font-normal text-sm cursor-pointer items-center"
                      >
                        {t("Add Expiry")}
                      </div>
                    )}
                </div> */}
                <div className="mb-5 mt-1 flex gap-3 flex-row md:gap-5">
                  <span className="w-[45%] leading-[0px] md:w-1/2">
                    {/* <label className="text-sm">{t("cost_price")}</label> */}
                    <InputBox
                      label={t("cost_price")}
                      reqiured={costingMethod === "AVCO"}
                      className={`${formik.errors.cost_price ? "border-red" : ""
                        }`}
                      name="cost_price"
                      type="text"
                      placeholder={t("Enter Cost Price")}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only valid decimal numbers and restrict to 7 digits total
                        if (
                          value === "" || // Allow empty input
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) // Allow numbers with up to 6 digits before decimal and 2 after
                        ) {
                          // Prevent multiple hyphens and other invalid characters
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("cost_price", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.cost_price}
                      error={formik.errors.cost_price}
                      touched={formik.errors.cost_price}
                      disabled={isAddBarcodeModalOpen}
                    />
                  </span>
                  <span className="inline-block w-[45%] leading-[0px] md:w-1/2">
                    {/* <label className="text-sm">{t("sale_price")}</label> */}
                    <InputBox
                      label={t("sale_price")}
                      reqiured={costingMethod === "AVCO"}
                      name="sale_price"
                      type="text"
                      // className={`${
                      //   formik.errors.sale_price ? "border-red" : ""
                      // }`}
                      placeholder={t("Enter Sale Price")}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only valid decimal numbers and restrict to 7 digits total
                        if (
                          value === "" || // Allow empty input
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) // Allow numbers with up to 6 digits before decimal and 2 after
                        ) {
                          // Prevent multiple hyphens and other invalid characters
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("sale_price", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.sale_price}
                      error={formik.errors.sale_price}
                      disabled={isAddBarcodeModalOpen}

                    // touched={formik.errors.sale_price}
                    />
                  </span>
                  {/* <span className="inline-block w-[50%] leading-[0px]">
                    <InputBox
                      label={t("Discounted Price")}
                      name="discounted_price"
                      type="text"
                      placeholder={t("Enter Discounted Price")}
                      onChange={(event) => {
                        const { value } = event.target;

                        if (
                          value === "" || // Allow empty input
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) // Allow numbers with up to 6 digits before decimal and 2 after
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("discounted_price", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.discounted_price}
                      error={formik.errors.discounted_price}
                      disabled={isAddBarcodeModalOpen}
                    />
                  </span> */}
                </div>
                <div className="mt-4 md:mt-8 flex flex-row gap-3 sm:gap-5 w-[90%] md:w-[45%]">
                  <button
                    type="submit"
                    // onClick={formik.handleChange}
                    onClick={(e) => {
                      if (!checkPermission("/inventory/InventoryOnboard")) {
                        e.preventDefault(); // prevent form submission
                        // toast.error("You do not have permission to perform this action.");
                        return;
                      }
                      formik.handleChange(e);
                    }}
                    className={`flex h-12 w-[90%] md:w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white sm:w-48 ${isSaveDisabled ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    disabled={isSaveDisabled}
                  // className="w-48 h-12 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
                  >
                    <span>{t("Save & Add more")}</span>
                  </button>
                  <Button
                    type="button"
                    className="h-12 w-[90%] md:w-full rounded-lg border-primaryBlue text-sm font-bold text-primaryBlue"
                    onClick={() => {
                      formik.resetForm();
                      setValue("");
                      setProductoptions([]);
                      setProductImage();
                      setAvailableQty("");
                      formik.setFieldValue("product_name2", "");
                      formik.setFieldValue("egs_code", "");
                      formik.setFieldValue("groups", []);
                      formik.setFieldValue("prevTextId", null);
                      formik.setFieldValue("tax_id", null);
                      formik.setFieldValue("isinclusive", null);
                      formik.setFieldValue("machine_barcode", "");

                      setSelectedGroups([]);
                      formik.setFieldValue("productShortcut", "");

                      setProductUom("");
                      setIsPackage(false);

                      setProdUpdateState("");
                      setIsProductSelected(false);
                      ShowAddPackagesContainer(false);
                      setPackagesArray([]);
                    }}
                  >
                    {t("Cancel")}
                  </Button>
                </div>
              </form>
            </div>
            <div className="p-2 md:m-2 md:p-4">
              <span
                  className={`flex  flex-col w-80 md:w-72 h-36 md:h-80 border rounded-xl relative top-4 ${
                    i18n.language == "en"
                      ? "left-0"
                      : "right-0 "
                  } justify-center items-center `}
              >
                {ProductImage ? (
                  <Image
                    src={ProductImage}
                    style={{ maxHeight: 280, maxWidth: 280 }}
                    height={isMobile ? 120 : 280}
                    width={isMobile ? 120 : 280}
                    alt="Image"
                    objectFit="contain"
                    className="rounded-xl"
                  />
                ) : (
                  <svg
                    className="float-left h-10 w-12 text-gray-300"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                    />
                  </svg>
                )}
              </span>
              <div className="relative top-2 flex gap-3 md:left-20 md:top-10"></div>
            </div>
          </div>
        </div>
        <AddBarcode
          isOpen={addBarcode || addSecondarBarcode}
          onClose={() => {
            setAddBarcode(false);
            setAddSecondaryBarcode(false);
            // setIsAddBarcodeModalOpen(false);
          }}
          prod_id={selectedProductId}
          onBarcodeAdded={(newBarcode) => {
            if (addSecondarBarcode) {
              formik.setFieldValue("secondaryBarcode", newBarcode); // Automatically fill the barcode field
              setAddSecondaryBarcode(false); // Close the modal after adding the barcode
              setIsAddBarcodeModalOpen(false);
            } else {
              formik.setFieldValue("barcode", newBarcode); // Automatically fill the barcode field
              setAddBarcode(false); // Close the modal after adding the barcode
              setIsAddBarcodeModalOpen(false);
            }
          }}
          setIsAddBarcodeModalOpen={setIsAddBarcodeModalOpen}
        // onBarcodeAdded={handleBarcodeAdded}
        />
        {popup && (
          <InventoryOnboardPopup
            message={message}
            onClose={() => setpopup(false)}
          />
        )}
        <ExpiryModal
          visible={openExpiryModal}
          onClose={() => setOpenExpiryModal(false)}
          onSave={handleSaveExpiryData}
          productIndex={0}
          initialData={savedExpiryData ? savedExpiryData?.expiryData : []}
          purchaseQty={formik.values.qty}
          freeQty={0}
          initialAlertDays={existingExpiryData?.alertDays}
          initialExpiryAlert={existingExpiryData?.expiryAlert}
        />
      </div>
    </>
  );
};

export default InventoryOnboard;
